import React from 'react';
import { SegmentedBool } from './SegmentedBool';

function SettingsRow({ label, description, highlighted, children, alignItems = 'center' }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems,
        justifyContent: 'space-between',
        padding: '14px 18px',
        border: `1.5px solid ${highlighted ? '#FFD9B8' : '#e4e7ec'}`,
        borderRadius: 10,
        background: highlighted ? '#FFFBF2' : '#fff',
        marginBottom: 12,
        transition: 'background 0.15s, border-color 0.15s',
        gap: 16,
      }}
    >
      <div style={{ minWidth: 0, flex: '1 1 auto' }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#181436', marginBottom: 3 }}>{label}</div>
        {description && <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.5 }}>{description}</div>}
      </div>
      <div style={{ flexShrink: 0 }}>{children}</div>
    </div>
  );
}

/**
 * Same shell as menu toggles — use for non-boolean controls (e.g. currency, text).
 * Default `alignItems: flex-start` so multi-line copy and tall controls align cleanly with the label.
 */
export function FieldRow({ label, description, children, alignItems = 'flex-start' }) {
  return (
    <SettingsRow label={label} description={description} highlighted={false} alignItems={alignItems}>
      {children}
    </SettingsRow>
  );
}

/** Card-style toggle row used in Menu Availability */
export function ToggleCard({ label, description, value, onChange }) {
  return (
    <SettingsRow label={label} description={description} highlighted={value} alignItems='center'>
      <SegmentedBool value={value} onChange={onChange} embedded />
    </SettingsRow>
  );
}
